import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  isExamSubmittedByHead,
  submitApi,
  submitWarning,
  saveOptions,
  submitStatus,
  submitWarningSubWise,
  subjectSubmitApi,
  timeTakenApi,
} from "../../services/service";
import { useAttemptedQuestions } from "../../context/AttemptedQuestionsContext";
import { leftTime as examWiseTime } from "../../components/TimerComponent";
import { leftTime as subjectWiseTime } from "../../components/TimerComponentSubject";
import socket from "../../socket/socket";
import ROUTES_NAME from "../../constants/RoutesName";
import { decryptData, encryptData } from "../../crypto";
import { useQuestionRecord } from "../../context/QuestionRecord";
import { changeSubjectTimeUtil } from "../../components/TimerComponentSubject";
import { useTimer } from "../../context/TimerContext";

export const useQuestionSection = ({
  questionData,
  currentQuestion,
  setCurrentQuestion,
  subjectId,
  activeSectionId,
  activeSubjectId,

  subjectNames,
  enableTimer = false,
  saveBeforeSubmitRef,
}) => {
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [selectedOptionIds, setSelectedOptionIds] = useState([]);
  const [inputAnswer, setInputAnswer] = useState("");
  const [matrixAnswer, setMatrixAnswer] = useState({});
  const [text, setText] = useState(null);

  const [showSubmissionPopup, setShowSubmissionPopup] = useState(false);
  const [showSubmissionPopupReLogin, setShowSubmissionPopupReLogin] =
    useState(false);
  const [showServerErrorDialog, setShowServerErrorDialog] = useState(false);
  const [isClearClicked, setIsClearClicked] = useState("");
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [countdownTime, setCountdownTime] = useState(10);
  const [finalSubmitChecked, setFinalSubmitChecked] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [countdownByHead, setCountdownByHead] = useState(0);
  const [questionWiseTime, setQuestionWiseTime] = useState(1);

  const [nextSubjectCounter, setNextSubjectCounter] = useState(0);
  const [isSubjectSubmit, setIsSubjectSubmit] = useState(false);
  const [isSubjectTimeUp, setIsSubjectTimeUp] = useState(false);
  const { setRemainingTime } = useTimer();

  const isSSC =
    decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway" ||
    decryptData(sessionStorage.getItem("exam_template")) === "ipmat";
  const [openMandatory, setOpenMandatory] = useState(false);

  const isDefault =
    decryptData(sessionStorage.getItem("exam_template")) === "default";

  const [stats, setStats] = useState({
    totalQuestions: "",
    notViewedQ: "",
    attemptedWithAnswered: "",
    attemptedWithoutAnswered: "",
    markedWithAnswered: "",
    markedWithotAnswered: "",
  });

  const navigate = useNavigate();
  const { attemptedQuestions, fetchAttemptedQuestions, attemptedLoader } =
    useAttemptedQuestions();

  const {
    addQuestionRecord,
    questionRecords,
    getQuestionRecordById,
    hasAnyAttemptedOrMarked,
  } = useQuestionRecord();

  // console.log("questionsrecordsss",questionRecords);

  const question = questionData ? questionData[currentQuestion] : {};
  const nextCurrentQuestion = currentQuestion + 1;
  const nextQuestion = questionData ? questionData[nextCurrentQuestion] : {};
  const timerRef = useRef(null);
  const isNavigatingRef = useRef(false);
  // Use subject-wise timer for subject_wise exams (except for demo/test user 4660)
  const leftTime =
    (sessionStorage.getItem("subject_wise") === "yes" &&
      sessionStorage.getItem("userId") !== "4660"
      ? subjectWiseTime
      : examWiseTime) || sessionStorage.getItem("remainingTime");
  // Load previously selected option if already attempted
  useEffect(() => {
    let attempted = questionRecords?.find(
      (aq) => Number(aq.question_id) === question?.id,
    );

    // if (isSSC) {
    //   attempted = questionRecords?.find(
    //     (aq) => Number(aq.question_id) === question?.id
    //   );
    // } else {
    //   attempted = attemptedQuestions?.find(
    //     (aq) => Number(aq.question_id) === question?.id
    //   );
    // }

    if (question?.question_type === "Multiple Choice") {
      setSelectedOptionIds(attempted?.multiple_option_ids || []);
    } else if (
      question?.question_type === "Fill In The Blanks" ||
      question?.question_type === "Range"
    ) {
      setInputAnswer(attempted?.answer || "");
    } else if (question?.question_type?.includes("Match")) {
      setMatrixAnswer(attempted?.match_matrix || "");
    } else if (question?.question_type === "Essay Writing") {
      setText(attempted?.text || "");
    } else {
      setSelectedOptionId(attempted?.option_id || null);
    }
    // Reset clear state when question changes
    setIsClearClicked("");
  }, [currentQuestion, question, attemptedQuestions, questionRecords]);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    if (isTimeUp && !isSSC) {
      submitWarningAPI(examId);
      setShowSubmitModal(true);
      const timer = setInterval(() => {
        setCountdownTime((prevTime) => prevTime - 1);
      }, 1000);

      const timeout = setTimeout(() => {
        clearInterval(timer);
        handleFinalSubmit("time");
        // sessionStorage.clear();
        // navigate(ROUTES_NAME.LOGIN);
      }, 10000);

      return () => {
        clearTimeout(timeout);
        clearInterval(timer);
      };
    }
  }, [isTimeUp]);
  const prevQuestionIdRef = useRef(null);

  useEffect(() => {
    if (attemptedLoader || !question?.id) return;

    const sessionKey = `temp_time`;

    // Reset timer to 0 on question change, but keep the session time if it's a page reload
    const isQuestionChange = prevQuestionIdRef.current !== null && prevQuestionIdRef.current !== question.id;
    prevQuestionIdRef.current = question.id;

    if (isQuestionChange) {
      sessionStorage.setItem(sessionKey, 0);
    }

    const sessionTime = Number(sessionStorage.getItem(sessionKey)) || 1;
    const initialTime = sessionTime || 1;

    setQuestionWiseTime(initialTime);

    if (!enableTimer) return;

    sessionStorage.setItem(sessionKey, initialTime);

    // Start the per-second timer
    const interval = setInterval(() => {
      setQuestionWiseTime((prev) => {
        const next = prev + 1;
        sessionStorage.setItem(sessionKey, next);
        // console.log(`[Timer] Q: ${question?.q_prifix} | Time: ${next}s`);
        return next;
      });
    }, 1000);

    // Cleanup when question/section/subject changes or component unmounts
    return () => clearInterval(interval);
  }, [question?.id, activeSectionId, activeSubjectId, attemptedLoader, enableTimer]);


  const [hasInitialized, setHasInitialized] = useState(false);

  // useEffect(() => {
  //   if (!hasInitialized && currentQuestion === 0) {
  //     next(0);
  //     setHasInitialized(true);
  //   }
  // }, [activeSectionId]);

  const resetSelections = () => {
    setSelectedOptionId(null);
    setSelectedOptionIds([]);
    setInputAnswer("");
    setMatrixAnswer({});
  };

  const handleSubjectSubmit = async (skipSave = false) => {
    const examId = sessionStorage.getItem("examId");
    try {
      // Use the QuestionSection's ref first (correct filtered context), else fall back
      if (!skipSave) {
        if (saveBeforeSubmitRef?.current) {
          await saveBeforeSubmitRef.current();
        } else if (question?.id) {
          await handleNavigationSave();
        }
      }
      const response = await subjectSubmitApi(examId, activeSubjectId);
      if (response.success) {
        setIsSubjectSubmit(true);
        setNextSubjectCounter(10); // Start countdown for next subject

        // Store submitted subject
        const submitted = JSON.parse(
          sessionStorage.getItem("submitted_subjects") || "[]",
        );
        submitted.push(activeSubjectId);
        sessionStorage.setItem("submitted_subjects", JSON.stringify(submitted));
      }
    } catch (error) {
      console.error("Subject submit error:", error);
      setSubmitError(error.response?.data.message || "Submission failed");
    }
  };

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    submitWarningAPI(examId);

    if (isSubjectTimeUp) {
      handleSubjectSubmit(); // New dedicated function for subject submit
    }
  }, [isSubjectTimeUp]);

  useEffect(() => {
    if (isSubjectSubmit) {
      setNextSubjectCounter(10);

      const timer = setInterval(() => {
        setNextSubjectCounter((prevTime) => prevTime - 1);
      }, 1000);

      const timeout = setTimeout(() => {
        clearInterval(timer);
        nextSubject();
      }, 10000);

      return () => {
        clearTimeout(timeout);
        clearInterval(timer);
      };
    }
  }, [isSubjectSubmit]);
  const enterFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log("Fullscreen error:", err);
        // Optionally fallback to F11 suggestion
        // alert("Please use F11 for fullscreen");
      });
    }
  };

  const nextSubject = () => {
    const submitted = JSON.parse(
      sessionStorage.getItem("submitted_subjects") || "[]",
    );
    sessionStorage.removeItem("subject_submit");

    const nextIndex = subjectNames.findIndex(
      (subject) => !submitted.includes(subject.subject_id),
    );
    if (nextIndex >= 0) {
      // setActiveSubjectId(subjectNames[nextIndex].subject_id);
      // setActiveSectionId(sectionNames[nextIndex][0].section_id);
      setCurrentQuestion(0);
      setIsSubjectSubmit(false);
      setIsSubjectTimeUp(false);
      setNextSubjectCounter(0);
      // Reset timer for new subject
      const newTime = changeSubjectTimeUtil(
        subjectNames[nextIndex].subject_id,
        false,
      );
      setRemainingTime(newTime);
      sessionStorage.removeItem("isOnsubmit");
      sessionStorage.removeItem("isTimeUp");
      sessionStorage.removeItem("subject_timeUp");
      // window.location.reload();
      // enterFullscreen()
    }
  };

  const navigateBasedOnStateBySubmissionOfHead = (examResult) => {
    const currentInstantResultState =
      sessionStorage.getItem("examInstantResult");
    const centerFeedback = sessionStorage.getItem("center_feedback");
    if (currentInstantResultState === "no") {
      if (centerFeedback === "yes") {
        navigate(ROUTES_NAME.CENTER_FEEDBACK);
      } else {
        navigate(ROUTES_NAME.THANK_YOU);
      }
    } else {
      navigate(ROUTES_NAME.EXAM_SCORE, { state: { examResult } });
    }
  };

  const submitWarningAPI = async (examId) => {
    if (sessionStorage.getItem("subject_wise") !== "yes") {
      try {
        const submitWarningData = await submitWarning(examId);
        setStats({
          totalQuestions: submitWarningData.totalQuestions,
          notViewedQ: submitWarningData.notViwed,
          attemptedWithAnswered: submitWarningData.attemptedWithAnswered,
          attemptedWithoutAnswered: submitWarningData.attemptedWithoutAnswered,
          markedWithAnswered: submitWarningData.markedWithAnswered,
          markedWithotAnswered: submitWarningData.markedWithotAnswered,
        });
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    } else {
      try {
        if (activeSubjectId) {
          const response = await submitWarningSubWise(examId, activeSubjectId);
          if (response.success) {
            setStats({
              submitWarningData: response,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    }
  };

  const isExamSubmittedByHeadCheck = async () => {
    const examId = sessionStorage.getItem("examId");
    submitWarningAPI(examId);
    try {
      if (question?.id) await handleSaveNextDefault(false, true);
      // const response = await isExamSubmittedByHead(examId);
      // if (response.status) {
      setShowSubmissionPopup(true);
      sessionStorage.setItem("submitByH", true);
      let timer = 10;
      const countdownInterval = setInterval(() => {
        setCountdownByHead(timer);
        if (timer === 1) {
          clearInterval(countdownInterval);
          setShowSubmissionPopup(false);

          const branch_id = sessionStorage.getItem("selectedBranch");
          const center_id = sessionStorage.getItem("selectedCenter");
          const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
          const exam_name = decryptData(sessionStorage.getItem("exam_name"));
          const centerFeedback = sessionStorage.getItem("center_feedback");
          const examId = sessionStorage.getItem("examId");
          const examToken = sessionStorage.getItem("examToken");
          const userName = sessionStorage.getItem("userName");
          const demoExamId = sessionStorage.getItem("demoExamId");
          sessionStorage.clear();
          sessionStorage.setItem("exam_name", encryptData(exam_name));
          sessionStorage.setItem("selectedBranch", branch_id);
          sessionStorage.setItem("selectedCenter", center_id);
          sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
          sessionStorage.setItem("candidateLoggedinToDashboard", true);
          if (centerFeedback === "yes") {
            sessionStorage.setItem("center_feedback", "yes");
            sessionStorage.setItem("examId", examId);
            sessionStorage.setItem("examToken", examToken);
            sessionStorage.setItem("userName", userName);
            if (demoExamId) {
              sessionStorage.setItem("demoExamId", demoExamId);
            }
            navigate(ROUTES_NAME.CENTER_FEEDBACK);
          } else {
            navigate(ROUTES_NAME.THANK_YOU);
          }

          // const branch_id = sessionStorage.getItem("selectedBranch");
          // const center_id = sessionStorage.getItem("selectedCenter");
          // const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
          // navigateBasedOnStateBySubmissionOfHead(response.examResult);
          // sessionStorage.clear();
          // sessionStorage.setItem("selectedBranch", branch_id);
          // sessionStorage.setItem("selectedCenter", center_id);
          // sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
        }
        timer--;
      }, 1000);
      // }
    } catch (error) {
      console.error("Error submitting exam:", error);
      setSubmitError(error.response?.data.message || "Unknown error");
    }
  };

  const handleFinalSubmit = async (type) => {
    const examId = sessionStorage.getItem("examId");

    // Find current subject and section indices
    const subjectCurrentIndex = subjectNames?.findIndex(
      (item) => item.subject_id === activeSubjectId,
    );

    const isLastSectionOfLastSubject =
      subjectCurrentIndex === subjectNames?.length - 1;

    if (
      sessionStorage.getItem("subject_wise") !== "yes" ||
      isLastSectionOfLastSubject
    ) {
      try {
        if (question?.id) await handleSaveNextDefault(false, true);
        const response = await submitApi({ examId, type });
        // const response = await submitStatus(examId);
        if (response.success === false) {
          setShowServerErrorDialog(true);
          return;
        }
        if (response.success) {
          setShowSubmitModal(false);
          const examId = sessionStorage.getItem("examId");
          const userId = sessionStorage.getItem("userId");
          socket.emit("changeStatus", {
            examId,
            userId,
            status: "Submitted",
          });

          const branch_id = sessionStorage.getItem("selectedBranch");
          const center_id = sessionStorage.getItem("selectedCenter");
          const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
          const exam_name = decryptData(sessionStorage.getItem("exam_name"));
          const centerFeedback = sessionStorage.getItem("center_feedback");
          const examToken = sessionStorage.getItem("examToken");
          const userName = sessionStorage.getItem("userName");
          const demoExamId = sessionStorage.getItem("demoExamId");
          sessionStorage.clear();
          sessionStorage.setItem("exam_name", encryptData(exam_name));
          sessionStorage.setItem("selectedBranch", branch_id);
          sessionStorage.setItem("userId", userId);
          sessionStorage.setItem("selectedCenter", center_id);
          sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
          sessionStorage.setItem("candidateLoggedinToDashboard", true);

          if (userId === "4660") {
            navigate(ROUTES_NAME.EXAM_SCORE, {
              state: { examResult: JSON.parse(response.examResult).result },
            });
            sessionStorage.setItem("examId", examId);
          } else {
            if (centerFeedback === "yes") {
              sessionStorage.setItem("center_feedback", "yes");
              sessionStorage.setItem("examId", examId);
              sessionStorage.setItem("examToken", examToken);
              sessionStorage.setItem("userName", userName);
              if (demoExamId) {
                sessionStorage.setItem("demoExamId", demoExamId);
              }
              navigate(ROUTES_NAME.CENTER_FEEDBACK);
            } else {
              navigate(ROUTES_NAME.THANK_YOU);
            }
          }
          // const branch_id = sessionStorage.getItem("selectedBranch");
          // const center_id = sessionStorage.getItem("selectedCenter");
          // const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
          // navigateBasedOnStateBySubmissionOfHead(response.examResult);
          // sessionStorage.clear();
          // sessionStorage.setItem("selectedBranch", branch_id);
          // sessionStorage.setItem("selectedCenter", center_id);
          // sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
        }
      } catch (error) {
        console.error("Error submitting exam:", error);
        setSubmitError(error.response?.data.message || "Unknown error");
      }
    } else {
      try {
        if (question?.id) await handleSaveNextDefault(false, true);
        const response = await subjectSubmitApi(examId, activeSubjectId);
        // if (response.success === false) {
        //   setShowServerErrorDialog(true);
        //   return;
        // }
        if (response.success) {
          setIsSubjectSubmit(true);
        }
      } catch (error) {
        console.error("Error submitting exam:", error);
        setSubmitError(error.response?.data.message || "Unknown error");
      }
    }
  };

  const next = async (currentQuestion) => {
    const isAttempted = attemptedQuestions?.filter(
      (aq) =>
        Number(aq.question_id) === Number(questionData[currentQuestion]?.id),
    );

    if (
      questionData?.[currentQuestion]?.id &&
      decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway" &&
      isAttempted.length === 0
    ) {
      const examId = sessionStorage.getItem("examId");
      const isMultipleChoice =
        questionData[currentQuestion]?.question_type === "Multiple Choice";
      const isInputType =
        questionData[currentQuestion]?.question_type === "Fill In The Blanks";

      const data = {
        attempt_status: "",
        exam_id: examId,
        option_id: isMultipleChoice ? [] : "",
        question_id: questionData[currentQuestion]?.id,
        remaining_time:
          isSubjectTimeUp ||
            isTimeUp ||
            sessionStorage.getItem("subject_timeUp") === "yes" ||
            sessionStorage.getItem("isTimeUp") === "true"
            ? "00:00:01"
            : leftTime,
        subject_id: subjectId,
        currentQuestion,
      };

      try {
        const response = await saveOptions(data);
        if (response) {
          resetSelections();
          fetchAttemptedQuestions(examId);
          setHasInitialized(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSaveNext = async () => {
    // await isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
        ? inputAnswer
        : selectedOptionId;

    if (!option_id_to_save || option_id_to_save?.length === 0) {
      if (isInputType) {
        alert("Please enter your answer");
      } else {
        alert("Please select a option");
      }
      return;
    }

    const data = {
      attempt_status: "attempted",
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: question?.id,
      remaining_time:
        isSubjectTimeUp ||
          isTimeUp ||
          sessionStorage.getItem("subject_timeUp") === "yes" ||
          sessionStorage.getItem("isTimeUp") === "true"
          ? "00:00:01"
          : leftTime,
      subject_id: subjectId,
      currentQuestion,
      time_taken:
        Number(sessionStorage.getItem(`temp_time`)) ||
        questionWiseTime,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        resetSelections();
        fetchAttemptedQuestions(examId);
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSaveNextDefault = async (moveNext = true, isSubmit = false) => {
    // await isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isEssayWriting = question?.question_type === "Essay Writing";
    const isInputType =
      question?.question_type === "Fill In The Blanks" ||
      question?.question_type === "Range";
    const isMatch =
      question?.question_type === "Match" ||
      question?.question_type === "Match Matrix";
    const isMandatory = sessionStorage.getItem("exam_type") === "demo";

    let option_id_to_save;

    if (isMultipleChoice) {
      option_id_to_save = selectedOptionIds;
    } else if (isInputType) {
      option_id_to_save = inputAnswer;
    } else if (isMatch) {
      option_id_to_save = matrixAnswer;
    } else {
      option_id_to_save = selectedOptionId;
    }

    // if (
    //   isMandatory &&
    //   (!option_id_to_save ||
    //     option_id_to_save.length === 0 ||
    //     Object.keys(option_id_to_save).length === 0)
    // ) {
    //   // toast.warning("This question is mandatory, please attempt");
    //   setOpenMandatory(true);
    //   return false;
    // }

    const record = getQuestionRecordById(question?.id);
    if (!isSubmit && isMandatory && record?.attempt_status !== "marked") {
      let isEmpty = false;
      if (isMultipleChoice) {
        isEmpty = !option_id_to_save || option_id_to_save.length === 0;
      } else if (isInputType) {
        isEmpty = !option_id_to_save || option_id_to_save.trim() === "";
      } else if (isMatch) {
        isEmpty =
          !option_id_to_save || Object.keys(option_id_to_save).length === 0;
      } else {
        isEmpty =
          option_id_to_save === null ||
          option_id_to_save === undefined ||
          option_id_to_save === "";
      }
      if (isEmpty) {
        setOpenMandatory(true);
        return false;
      }
    }

    let attempt_status = "";

    if (isMultipleChoice) {
      if (option_id_to_save && option_id_to_save.length > 0) {
        attempt_status = "attempted";
      }
    } else if (isMatch) {
      if (Object.keys(option_id_to_save).length > 0) {
        attempt_status = "attempted";
      }
    } else if (isEssayWriting) {
      if (text) {
        attempt_status = "attempted";
      }
    } else {
      if (
        option_id_to_save !== null &&
        option_id_to_save !== undefined &&
        option_id_to_save !== ""
      ) {
        attempt_status = "attempted";
      }
    }

    // Determine clear value: if user selected a new option after clearing, clear should be empty
    let hasNewAnswer = false;
    if (isMultipleChoice) {
      if (option_id_to_save && option_id_to_save.length > 0) {
        attempt_status = "attempted";
      }
    } else if (isMatch) {
      if (option_id_to_save && Object.keys(option_id_to_save).length > 0) {
        attempt_status = "attempted";
      }
    } else if (isEssayWriting) {
      if (text && text.trim() !== "") {
        attempt_status = "attempted";
      }
    } else if (isInputType) {
      if (option_id_to_save && String(option_id_to_save).trim() !== "") {
        attempt_status = "attempted";
      }
    } else {
      if (
        option_id_to_save !== null &&
        option_id_to_save !== undefined &&
        option_id_to_save !== "" &&
        // Ensure we don't treat empty arrays from state restoration as truthy for single choice
        !(Array.isArray(option_id_to_save) && option_id_to_save.length === 0)
      ) {
        attempt_status = "attempted";
      }
    }

    const clearValue = hasNewAnswer ? "" : isClearClicked;

    const data = {
      attempt_status: attempt_status,
      exam_id: examId,
      option_id: isMatch ? null : option_id_to_save,
      match_matrix: isMatch ? option_id_to_save : null,
      question_id: question?.id,
      remaining_time:
        isSubjectTimeUp ||
          isTimeUp ||
          sessionStorage.getItem("subject_timeUp") === "yes" ||
          sessionStorage.getItem("isTimeUp") === "true"
          ? "00:00:01"
          : leftTime,
      section_id: isSSC && activeSectionId,
      subject_id: isSSC ? activeSubjectId : subjectId,
      time_taken:
        Number(sessionStorage.getItem(`temp_time`)) ||
        questionWiseTime,
      current_question: question?.q_prifix,
      next_question: nextQuestion?.q_prifix || question?.q_prifix + 1,
      clear: clearValue,
      text,
    };

    setIsClearClicked("");

    addQuestionRecord({
      ...data,
      attempt_status: attempt_status === "" ? "not answered" : attempt_status,
      //  isMultipleChoice
      //   ? option_id_to_save?.length > 0
      //     ? "attempted"
      //     : "not answered"
      //   : option_id_to_save
      //   ? "attempted"
      //   : "not answered",
      question_id: Number(question?.id),
      option_id: isMatch ? null : option_id_to_save,
      match_matrix: isMatch ? option_id_to_save : null,
      answer: isInputType ? option_id_to_save : null,
      multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
    });

    if (
      currentQuestion < questionData?.length - 1 &&
      (decryptData(sessionStorage.getItem("exam_template")) !== "default" ||
        decryptData(sessionStorage.getItem("exam_template")) === "ipmat")
    ) {
      setCurrentQuestion(currentQuestion + 1);
      fetchData(currentQuestion + 1);
    } else {
      setCurrentQuestion(0);
    }

    if (decryptData(sessionStorage.getItem("exam_template")) === "default") {
      // resetSelections();
      // fetchAttemptedQuestions(examId);
      if (currentQuestion < questionData?.length - 1 && moveNext) {
        setCurrentQuestion(currentQuestion + 1);
        next(currentQuestion + 1);
      }
    }
    resetSelections();
    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        // addQuestionRecord({
        //   ...data,
        //   attempt_status: isMultipleChoice
        //     ? option_id_to_save?.length > 0
        //       ? "attempted"
        //       : "not answered"
        //     : option_id_to_save
        //     ? "attempted"
        //     : "not answered",
        //   question_id: Number(question?.id),
        //   option_id: option_id_to_save,
        //   answer: isInputType ? option_id_to_save : null,
        //   multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
        // });

        // if (
        //   currentQuestion < questionData?.length - 1 &&
        //   decryptData(sessionStorage.getItem("exam_template")) !== "default"
        // ) {
        //   setCurrentQuestion(currentQuestion + 1);
        //   fetchData(currentQuestion + 1);
        // }

        // if (
        //   decryptData(sessionStorage.getItem("exam_template")) === "default"
        // ) {
        //   // resetSelections();
        //   // fetchAttemptedQuestions(examId);
        //   if (currentQuestion < questionData?.length - 1 && moveNext) {
        //     setCurrentQuestion(currentQuestion + 1);
        //     next(currentQuestion + 1);
        //   }
        // }
        // if (isMatch) {
        //   setMatrixAnswer({});
        // }
        addQuestionRecord({
          ...data,
          attempt_status: response?.attempt?.attempt_status,
          question_id: Number(response?.attempt?.question_id),
          option_id: isMatch ? null : response?.attempt?.option_id,
          match_matrix: isMatch ? response?.attempt?.match_matrix : null,
          answer: isInputType ? response?.attempt?.answer : null,
          multiple_option_ids: isMultipleChoice ? response?.attempt?.multiple_option_ids : null,
        });
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const fetchData = async (
    currentQuestion,
    call = true,
    status = "not answered",
  ) => {
    if (questionData?.[currentQuestion]?.id) {
      const currentQuestionId = questionData?.[currentQuestion]?.id;
      const questionRecord = getQuestionRecordById(currentQuestionId);

      const needsInitialSave =
        !questionRecord ||
        questionRecord.attempt_status === "not answered" ||
        questionRecord.attempt_status === "";

      if (needsInitialSave) {
        try {
          const examId = sessionStorage.getItem("examId");
          const currentQuestionType =
            questionData?.[currentQuestion]?.question_type;

          if (!currentQuestionId) return; // const q = questionRecords.find(
          //   (q) => Number(q?.question_id) === Number(currentQuestionId)
          // );

          const q = getQuestionRecordById(currentQuestionId);

          const ans =
            q?.answer ||
              q?.option_id ||
              q?.multiple_option_ids ||
              currentQuestionType === "Multiple Choice"
              ? []
              : null;

          const data = {
            attempt_status: "",
            exam_id: examId,
            option_id: ans,
            question_id: String(currentQuestionId),
            remaining_time: leftTime,
            subject_id: questionData?.[currentQuestion]?.subject_id,
            section_id: activeSectionId,
            currentQuestion,
          }; // Optimistic local update BEFORE API call

          addQuestionRecord({
            ...data,
            attempt_status: status,
            question_id: Number(currentQuestionId),
          });

          if (call) {
            const response = await saveOptions(data);
            if (response.success === false) {
              setShowServerErrorDialog(true);
              return;
            }
          }
        } catch (error) {
          console.error("Error saving question status:", error);
        }
      }
    }
  };

  const isSubjectWiseExam = sessionStorage.getItem("subject_wise") === "yes";
  const isSectionFetchReady =
    !isSubjectWiseExam ||
    !activeSubjectId ||
    sessionStorage.getItem(`timerInitialized_${activeSubjectId}`) === "true";

  useEffect(() => {
    if (!activeSectionId || !questionData || questionData.length === 0) return;
    if (!isSectionFetchReady) return;

    const sectionKey = `${activeSubjectId || "default"}_${activeSectionId}`;

    if (
      sessionStorage.getItem("lastFetchedSec") !== sectionKey &&
      leftTime
    ) {
      sessionStorage.setItem("lastFetchedSec", sectionKey);
      fetchData(0, true, "not answered");
    }
  }, [activeSectionId, activeSubjectId, leftTime, questionData, isSectionFetchReady]);

  const previousQuestion = async (q) => {
    // const oldData = attemptedQuestions.filter(
    //   (aq) => Number(aq.question_id) === Number(question.id)
    // );
    const oldData = questionRecords?.filter(
      (aq) => Number(aq.question_id) === Number(question.id),
    );
    const examId = sessionStorage.getItem("examId");
    const ml = question.question_type === "Multiple Choice";
    const isInputType =
      question?.question_type === "Fill In The Blanks" ||
      question?.question_type === "Range";
    const isMatch =
      question?.question_type === "Match" ||
      question?.question_type === "Match Matrix";

    if (oldData.length > 0) {
      const getAns = () => {
        if (ml && oldData[0]?.multiple_option_ids) {
          return oldData[0]?.multiple_option_ids;
        } else if (ml) {
          return [];
        } else if (isInputType) {
          return oldData[0]?.answer;
        } else if (isMatch) {
          return null;
        } else if (oldData[0]?.option_id) {
          return oldData[0]?.option_id;
        } else {
          return "";
        }
      };

      const data = {
        attempt_status: oldData[0]?.attempt_status,
        exam_id: examId,
        option_id: getAns(),
        match_matrix: isMatch ? oldData[0]?.match_matrix : null,
        question_id: oldData[0]?.question_id,
        remaining_time: leftTime,
        section_id: isSSC && activeSectionId,
        subject_id: isSSC ? activeSubjectId : subjectId,
        time_taken:
          Number(sessionStorage.getItem(`temp_time`)) ||
          questionWiseTime,
        current_question: question?.q_prifix,
        next_question: q?.q_prifix,
      };

      addQuestionRecord({
        ...data,
        question_id: Number(question?.id),
        option_id: oldData[0]?.option_id || "",
        answer: oldData[0]?.answer || null,
        multiple_option_ids: oldData[0]?.multiple_option_ids || null,
        match_matrix: oldData[0]?.match_matrix || null,
      });

      try {
        const response = await saveOptions(data);
        if (response.success === false) {
          setShowServerErrorDialog(true);
          return;
        }

        if (response) {
          // addQuestionRecord({
          //   ...data,
          //   question_id: Number(question?.id),
          //   option_id: oldData[0]?.option_id || "",
          //   answer: oldData[0]?.answer || null,
          //   multiple_option_ids: oldData[0]?.multiple_option_ids || null,
          // });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      const isMultipleChoice = question?.question_type === "Multiple Choice";

      const data = {
        attempt_status: "",
        exam_id: examId,
        // option_id: isMultipleChoice ? [] : "",
        option_id: isMatch ? null : isMultipleChoice ? [] : "",
        match_matrix: isMatch ? {} : null,
        question_id: question.id,
        remaining_time: leftTime,
        section_id: isSSC && activeSectionId,
        subject_id: isSSC ? activeSubjectId : subjectId,
        time_taken:
          Number(sessionStorage.getItem(`temp_time`)) ||
          questionWiseTime,
        current_question: question?.q_prifix,
        next_question: q?.q_prifix,
      };

      addQuestionRecord({
        ...data,
        question_id: Number(question?.id),
        option_id: "",
        answer: null,
        match_matrix: null,
        multiple_option_ids: null,
        section_id: activeSectionId,
        subject_id: activeSubjectId,
      });

      try {
        const response = await saveOptions(data);
        if (response.success === false) {
          setShowServerErrorDialog(true);
          return;
        }

        if (response) {
          // addQuestionRecord({
          //   ...data,
          //   question_id: Number(question?.id),
          //   option_id: "",
          //   answer: null,
          //   multiple_option_ids: null,
          //   section_id: activeSectionId,
          //   subject_id: activeSubjectId,
          // });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDClick = async (q, status, idx) => {
    // await isExamSubmittedByHeadCheck();
    await handleTimeTaken()
    // previousQuestion(q);

    if (status !== "notVisited") return;

    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = q?.question_type === "Multiple Choice";
    const isInputType = q?.question_type === "Fill In The Blanks";

    // console.log("question", question?.q_prifix, q?.q_prifix);

    const data = {
      attempt_status: "",
      exam_id: examId,
      option_id: isMultipleChoice ? [] : "",
      question_id: q?.id,
      remaining_time: leftTime,
      section_id: isSSC && activeSectionId,
      subject_id: isSSC ? activeSubjectId : subjectId,
      currentQuestion,
      // time_taken: questionWiseTime,
      // current_question: question?.q_prifix,
      // next_question: q?.q_prifix,
    };

    addQuestionRecord({
      ...data,
      option_id: null,
      answer: null,
      multiple_option_ids: null,
      attempt_status: "not answered",
      // time_taken:0
    });
    fetchData(idx, false);

    try {
      const response = await saveOptions(data);

      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        // resetSelections();
        // fetchAttemptedQuestions(examId);
        // addQuestionRecord({
        //   ...data,
        //   option_id: null,
        //   answer: null,
        //   multiple_option_ids: null,
        //   attempt_status: "not answered",
        // });
        // fetchData(idx, false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Other handler functions (handleMarkReview, handleClearResponse, handleBack, handleNext)
  // would follow the same pattern...
  const handleNext = () => {
    // isExamSubmittedByHeadCheck();
    if (currentQuestion < questionData?.length - 1) {
      resetSelections();
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handleMarkReview = async (status, showAlert = false) => {
    // isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
        ? inputAnswer
        : selectedOptionId;

    if ((!option_id_to_save || option_id_to_save?.length === 0) && showAlert) {
      isInputType
        ? alert("Please enter your answer")
        : alert("Please select a option");
      return;
    }

    if (!showAlert) {
      option_id_to_save = null;
    }
    if (!showAlert && isMultipleChoice) {
      option_id_to_save = [];
    }

    const data = {
      attempt_status: status,
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: question?.id,
      remaining_time: leftTime,
      subject_id: subjectId,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        resetSelections();
        fetchAttemptedQuestions(examId);
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMarkReviewDefault = async (status) => {
    // isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType =
      question?.question_type === "Fill In The Blanks" ||
      question?.question_type === "Range";
    const isMatch =
      question?.question_type === "Match" ||
      question?.question_type === "Match Matrix";
    const isMandatory = sessionStorage.getItem("exam_type") === "demo";

    let option_id_to_save;

    if (isMultipleChoice) {
      option_id_to_save = selectedOptionIds;
    } else if (isInputType) {
      option_id_to_save = inputAnswer;
    } else if (isMatch) {
      option_id_to_save = matrixAnswer;
    } else {
      option_id_to_save = selectedOptionId;
    }

    // if ((!option_id_to_save || option_id_to_save?.length === 0)) {
    //   if (currentQuestion < questionData?.length - 1) {
    //       setCurrentQuestion(currentQuestion + 1);
    //     }
    //   return;
    // }

    // console.log()

    // if (
    //   isMandatory &&
    //   (!option_id_to_save ||
    //     option_id_to_save.length === 0 ||
    //     Object.keys(option_id_to_save).length === 0)
    // ) {
    //   // toast.warning("This question is mandatory, please attempt");
    //   setOpenMandatory(true);
    //   return false;
    // }

    if (isMandatory) {
      let isEmpty = false;
      if (isMultipleChoice) {
        isEmpty = !option_id_to_save || option_id_to_save.length === 0;
      } else if (isInputType) {
        isEmpty = !option_id_to_save || option_id_to_save.trim() === "";
      } else if (isMatch) {
        isEmpty =
          !option_id_to_save || Object.keys(option_id_to_save).length === 0;
      } else {
        isEmpty =
          option_id_to_save === null ||
          option_id_to_save === undefined ||
          option_id_to_save === "";
      }
      if (isEmpty) {
        setOpenMandatory(true);
        return false;
      }
    }

    // Determine clear value: if user selected a new option after clearing, clear should be empty
    let hasNewAnswerForReview = false;
    if (isMultipleChoice) {
      hasNewAnswerForReview = option_id_to_save && option_id_to_save.length > 0;
    } else if (isMatch) {
      hasNewAnswerForReview =
        option_id_to_save && Object.keys(option_id_to_save).length > 0;
    } else if (isInputType) {
      hasNewAnswerForReview =
        option_id_to_save && option_id_to_save.trim() !== "";
    } else {
      hasNewAnswerForReview =
        option_id_to_save !== null &&
        option_id_to_save !== undefined &&
        option_id_to_save !== "";
    }

    const clearValueForReview = hasNewAnswerForReview ? "" : isClearClicked;

    const data = {
      attempt_status: status,
      exam_id: examId,
      option_id: isMatch ? null : option_id_to_save,
      match_matrix: isMatch ? option_id_to_save : null,
      question_id: question?.id,
      remaining_time: leftTime,
      section_id: isSSC && activeSectionId,
      subject_id: isSSC ? activeSubjectId : subjectId,
      time_taken:
        Number(sessionStorage.getItem(`temp_time`)) ||
        questionWiseTime,
      current_question: question?.q_prifix,
      next_question: nextQuestion?.q_prifix || question?.q_prifix + 1,
      clear: clearValueForReview,
    };

    setIsClearClicked("");

    addQuestionRecord({
      ...data,
      question_id: Number(question?.id),
      option_id: isMatch
        ? null
        : option_id_to_save?.length === 0
          ? null
          : option_id_to_save,
      answer: isInputType ? option_id_to_save : null,
      multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
      match_matrix: isMatch ? option_id_to_save : null,
    });

    if (
      currentQuestion < questionData?.length - 1 &&
      (decryptData(sessionStorage.getItem("exam_template")) !== "default" ||
        decryptData(sessionStorage.getItem("exam_template")) === "ipmat")
    ) {
      setCurrentQuestion(currentQuestion + 1);
      fetchData(currentQuestion + 1, true, "not answered");
    } else {
      setCurrentQuestion(0);
    }
    if (decryptData(sessionStorage.getItem("exam_template")) === "default") {
      // resetSelections();
      // fetchAttemptedQuestions(examId);
      if (currentQuestion < questionData?.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
        next(currentQuestion + 1);
      }
    }
    resetSelections();
    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        // addQuestionRecord({
        //   ...data,
        //   question_id: Number(question?.id),
        //   option_id: option_id_to_save?.length === 0 ? null : option_id_to_save,
        //   answer: isInputType ? option_id_to_save : null,
        //   multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
        // });

        // if (
        //   currentQuestion < questionData?.length - 1 &&
        //   decryptData(sessionStorage.getItem("exam_template")) !== "default"
        // ) {
        //   setCurrentQuestion(currentQuestion + 1);
        //   fetchData(currentQuestion + 1);
        // }
        // if (
        //   decryptData(sessionStorage.getItem("exam_template")) === "default"
        // ) {
        //   // resetSelections();
        //   // fetchAttemptedQuestions(examId);
        //   if (currentQuestion < questionData?.length - 1) {
        //     setCurrentQuestion(currentQuestion + 1);
        //     next(currentQuestion + 1);
        //   }
        // }
        addQuestionRecord({
          ...data,
          attempt_status: response?.attempt?.attempt_status,
          question_id: Number(response?.attempt?.question_id),
          option_id: isMatch ? null : response?.attempt?.option_id,
          match_matrix: isMatch ? response?.attempt?.match_matrix : null,
          answer: isInputType ? response?.attempt?.answer : null,
          multiple_option_ids: isMultipleChoice ? response?.attempt?.multiple_option_ids : null,
        });
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  // const handleClearResponse = () => {
  //   // isExamSubmittedByHeadCheck();
  //   resetSelections();
  //   setIsClearClicked("yes");
  //   console.log("clearresponceclicked",isClearClicked);

  // };

  const handleClearResponse = () => {
    // isExamSubmittedByHeadCheck();
    resetSelections();

    const record = questionRecords?.find(
      (aq) => Number(aq.question_id) === Number(question?.id),
    );

    const hasResponse =
      question?.question_type === "Multiple Choice"
        ? Array.isArray(record?.multiple_option_ids) &&
        record.multiple_option_ids.length > 0
        : question?.question_type === "Fill In The Blanks" ||
          question?.question_type === "Range"
          ? Boolean(record?.answer)
          : question?.question_type === "Match" ||
            question?.question_type === "Match Matrix"
            ? record?.match_matrix &&
            Object.keys(record.match_matrix).length > 0
            : record?.option_id !== null &&
            record?.option_id !== undefined &&
            record?.option_id !== "";

    setIsClearClicked(hasResponse ? "yes" : "");
    if (isDefault) {
      setIsClearClicked("");
    }
  };
  const handleNavigationSave = async () => {
    if (!question?.id) return;
    const examId = sessionStorage.getItem("examId");
    try {
      timeTakenApi({
        time_taken: {
          exam_id: examId || null,
          question_id: question?.id || null,
          time_taken: Number(sessionStorage.getItem(`temp_time`)) || questionWiseTime
        }

      }
      )
      //  sessionStorage.removeItem("temp_time");
    } catch (error) {
      console.error("[Time Taken API Error]", error);
    }
  };
  const handleTimeTaken = async () => {
    if (!question?.id) return;
    const examId = sessionStorage.getItem("examId");
    try {
      timeTakenApi({
        time_taken: {
          exam_id: examId || null,
          question_id: question?.id || null,
          time_taken: Number(sessionStorage.getItem(`temp_time`)) || questionWiseTime
        }

      }
      )
      //  sessionStorage.removeItem("temp_time");
    } catch (error) {
      console.error("[Time Taken API Error]", error);
    }
  };
  const handleBack = async () => {
    if (isNavigatingRef.current) return;
    isNavigatingRef.current = true;
    // isExamSubmittedByHeadCheck();
    try {
      await handleNavigationSave();
      if (currentQuestion > 0) {
        resetSelections();
        setCurrentQuestion(currentQuestion - 1);
      }
    } finally {
      isNavigatingRef.current = false;
    }

    let myQ = null;
    let id = null;

    if (isSSC) {
      myQ = questionData[currentQuestion - 1];
      id = questionData[currentQuestion - 1]?.id;
    } else {
      myQ = questionData[currentQuestion];
      id = questionData[currentQuestion]?.id;
    }

    // const myQ = questionData[currentQuestion - 1]
    // const id = questionData[currentQuestion - 1]?.id;

    if (getQuestionRecordById(id)) {
      return;
    }

    const examId = sessionStorage.getItem("examId");

    const isMultipleChoiceForBack = myQ?.question_type === "Multiple Choice";
    const isMatchForBack =
      myQ?.question_type === "Match" || myQ?.question_type === "Match Matrix";

    const data = {
      attempt_status: "",
      exam_id: examId,
      option_id: isMultipleChoiceForBack ? [] : null,
      match_matrix: isMatchForBack ? {} : null,
      question_id: id,
      remaining_time: leftTime,
      section_id: isSSC && activeSectionId,
      subject_id: isSSC ? activeSubjectId : subjectId,
      time_taken:
        Number(sessionStorage.getItem(`temp_time_${id}`)) || questionWiseTime,
      current_question: question?.q_prifix,
      next_question: myQ?.q_prifix,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        addQuestionRecord({
          ...data,
          attempt_status: "not answered",
          question_id: Number(id),
          option_id: isMultipleChoiceForBack ? [] : null,
          answer: null,
          multiple_option_ids: isMultipleChoiceForBack ? [] : null,
          match_matrix: isMatchForBack ? {} : null,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    socket.connect();
    const user = sessionStorage.getItem("userId");
    const exam = sessionStorage.getItem("examId");

    const startCountdown = () => {
      setShowSubmissionPopupReLogin(true);
      sessionStorage.setItem("relogin", true);
      let timer = 5;
      timerRef.current = setInterval(() => {
        setCountdownByHead(timer);
        if (timer === 1) {
          sessionStorage.clear();
          clearInterval(timerRef.current);
          setShowSubmissionPopupReLogin(false);
          navigate(ROUTES_NAME.LOGIN);
          window.location.reload();
        }
        timer--;
      }, 1000);
    };

    const handleExamSubmit = ({ examId, userId }) => {
      if (userId === user && examId === exam) isExamSubmittedByHeadCheck();
    };

    const handleExamSubmitAll = ({ examId }) => {
      if (examId === exam) isExamSubmittedByHeadCheck();
    };

    const handleReLogin = ({ examId, userId }) => {
      if (userId === sessionStorage.getItem("userId") && examId === exam)
        startCountdown();
    };

    const handleReLoginAll = ({ examId }) => {
      if (examId === exam) startCountdown();
    };

    const selectedLogout = ({ learnerIds }) => {
      if (learnerIds.map(String).includes(user)) {
        // console.log("learnerIds", learnerIds);
        startCountdown();
      }
    };

    if (!isSSC) {
      socket.on("exam_submit_check", handleExamSubmit);
      socket.on("exam_submit_check_all", handleExamSubmitAll);
    }
    socket.on("re_login", handleReLogin);
    socket.on("re_login_all", handleReLoginAll);
    socket.on("selected_logout", selectedLogout);

    if (sessionStorage.getItem("relogin")) {
      sessionStorage.clear();
      navigate(ROUTES_NAME.LOGIN);
      window.location.reload();
    }
    if (sessionStorage.getItem("submitByH")) {
      isExamSubmittedByHeadCheck();
    }

    return () => {
      socket.off("exam_submit_check", handleExamSubmit);
      socket.off("exam_submit_check_all", handleExamSubmitAll);
      socket.off("re_login", handleReLogin);
      socket.off("re_login_all", handleReLoginAll);
      socket.off("selected_logout", selectedLogout);

      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (saveBeforeSubmitRef) {
      saveBeforeSubmitRef.current = handleNavigationSave;
    }
  }, [handleNavigationSave, saveBeforeSubmitRef]);

  return {
    selectedOptionId,
    selectedOptionIds,
    inputAnswer,
    showSubmissionPopup,
    showSubmissionPopupReLogin,
    showServerErrorDialog,
    setShowServerErrorDialog,
    showSubmitModal,
    isTimeUp,
    countdownTime,
    finalSubmitChecked,
    submitError,
    countdownByHead,
    stats,
    handleOptionChange: (event) =>
      setSelectedOptionId(Number(event.target.value)),
    handleMultipleChoiceChange: (event, id) => {
      if (event.target.checked) {
        setSelectedOptionIds((prev) => [...prev, id]);
      } else {
        setSelectedOptionIds((prev) =>
          prev.filter((optionId) => optionId !== id),
        );
      }
    },
    handleInputChange: (event) => setInputAnswer(event.target.value),
    resetSelections,
    handleSaveNext,
    handleSaveNextDefault,
    handleMarkReview,
    handleMarkReviewDefault,
    handleClearResponse,
    handleBack,
    handleNext,
    handleDClick,
    handleOpenSubmitModal: async (skipMandatoryCheck = false) => {
      if (sessionStorage.getItem("subject_wise") === "yes") {
        // Save current question progress before subject-wise transition reload
        try {
          if (saveBeforeSubmitRef?.current) {
            await saveBeforeSubmitRef.current();
          } else if (question?.id) {
            await handleNavigationSave();
          }
        } catch (e) {
          console.warn(
            "Could not save question before subject submit reload:",
            e,
          );
        }

        // sessionStorage.setItem("subjectId", activeSubjectId);
        sessionStorage.setItem("subject_submit", "yes");
        window.location.reload();
      } else {
        if (
          !skipMandatoryCheck &&
          hasAnyAttemptedOrMarked() < Number(sessionStorage.getItem("total"))
        ) {
          setOpenMandatory(true);
          return false;
        }

        setShowSubmitModal(true);
        const examId = sessionStorage.getItem("examId");
        if (examId) submitWarningAPI(examId);
      }
    },
    handleCloseSubmitModal: () => setShowSubmitModal(false),
    handleFinalSubmitCheck: () => setFinalSubmitChecked(!finalSubmitChecked),
    handleFinalSubmit,
    setIsTimeUp,
    openMandatory,
    setOpenMandatory,
    handleSubjectSubmit,
    nextSubjectCounter,
    nextSubject,
    setIsSubjectTimeUp,
    isSubjectTimeUp,
    isSubjectSubmit,
    handleNavigationSave,
    setMatrixAnswer,
    matrixAnswer,
    text,
    setText,
  };
};
